import React, { useState, useContext, useEffect } from 'react';
import {
  FaUser, FaHome, FaTag, FaChevronDown, FaChevronUp, FaThLarge, FaUserMd,
  FaBusinessTime, FaCar, FaLandmark, FaCreditCard, FaShieldAlt, FaGlobe,
  FaMoneyBillAlt, FaRegAddressCard
} from 'react-icons/fa';
import { AiOutlineMenuFold, AiOutlineMenuUnfold } from 'react-icons/ai';
import { logout as apiLogout, getAdminById } from '../middleware/backend_hepler';
import { AuthContext } from '../Context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import employeeProfile from "../assets/default-profile.png"

const Sidebar = ({ isExpanded, onToggle }) => {
  const { adminRole, adminId } = useContext(AuthContext);
  const [isProductDropdownOpen, setIsProductDropdownOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState('dashboard');
  const [adminData, setAdminData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchAdminData = async () => {
      if (adminId) {
        try {
          const data = await getAdminById(adminId);
          console.log(data);

          setAdminData(data);
        } catch (error) {
          console.error('Failed to fetch admin data:', error);
        }
      }
    };

    fetchAdminData();
  }, [adminId]);

  const toggleProductDropdown = () => {
    setIsProductDropdownOpen(prevState => !prevState);
  };

  const handleProductClick = () => {
    if (!isExpanded) {
      onToggle();
    }
    toggleProductDropdown();
  };

  const handleProductSelect = (product, path) => {
    setSelectedProduct(product);
    navigate(path);
  };

  const handleDashboardSelect = () => {
    setSelectedProduct('dashboard');
    navigate('/dashboard');
  };

  const handleEmployeeSelect = () => {
    setSelectedProduct("employee");
    navigate("/employee-list");
  };

  const getInitials = (name) => {
    if (!name) return "";
    const names = name.split(" ");
    const initials = names.map((n) => n.charAt(0).toUpperCase()).join("");
    return initials;
  };

  useEffect(() => {
    const path = location.pathname;
    if (
      path.includes("/homeloanlist") ||
      path.includes("/create-home-loan") ||
      path.includes("/edit-home-loan")
    ) {
      setSelectedProduct("homeloan");
    } else if (
      path.includes("/personalloanlist") ||
      path.includes("/create-personal-loan") ||
      path.includes("/edit-personal-loan")
    ) {
      setSelectedProduct("personalloan");
    } else if (
      path.includes("/businessloanlist") ||
      path.includes("/create-business-loan") ||
      path.includes("/edit-business-loan")
    ) {
      setSelectedProduct("businessloan");
    } else if (
      path.includes("/carloanlist") ||
      path.includes("/create-car-loan") ||
      path.includes("/edit-car-loan")
    ) {
      setSelectedProduct("carloan");
    } else if (
      path.includes("/mortgageloanlist") ||
      path.includes("/create-mortgage-loan") ||
      path.includes("/edit-mortgage-loan")
    ) {
      setSelectedProduct("mortgageloan");
    } else if (
      path.includes("/creditcardlist") ||
      path.includes("/create-credit-card") ||
      path.includes("/edit-creditcard-loan")
    ) {
      setSelectedProduct("creditcard");
    } else if (
      path.includes("/insurancelist") ||
      path.includes("/create-insurance") ||
      path.includes("/edit-insurance-loan")
    ) {
      setSelectedProduct("insurance");
    } else if (
      path.includes("/doctorloanlist") ||
      path.includes("/create-doctor-loan") ||
      path.includes("/edit-doctor-loan")
    ) {
      setSelectedProduct("doctorloan");
    } else if (
      path.includes("/nriloanlist") ||
      path.includes("/create-nri-loan") ||
      path.includes("/edit-nri-loan")
    ) {
      setSelectedProduct("nriloan");
    }
    else if (
      path.includes("/banklist") ||
      path.includes("/create-bank") ||
      path.includes("/edit-bank") 
    ) {
      setSelectedProduct("bank");
    }
    else if (
      path.includes("/employee-list") ||
      path.includes("/create-employee") ||
      path.includes("/edit-employee")
    )
     {
      setSelectedProduct("employee");
    } 
    else if (
      path.includes("/companylist") ||
      path.includes("/create-company") ||
      path.includes("/edit-company") ||
      path.includes("/company-bulk-upload") ||
      path.includes("/company-bulk-delete")
      
    ) {
      setSelectedProduct("company");
    }else if (path === "/dashboard") {
      setSelectedProduct("dashboard");
    } else setSelectedProduct("");
  }, [location]);

  useEffect(() => {
    if (
      [
        "/homeloanlist",
        "/personalloanlist",
        "/businessloanlist",
        "/carloanlist",
        "/mortgageloanlist",
        "/creditcardlist",
        "/insurancelist",
        "/doctorloanlist",
        "/nriloanlist",
        "/banklist",
        "/employee-list",
        "/companylist",
      ].some((p) => location.pathname.includes(p))
    ) {
      setIsProductDropdownOpen(true);
    }
  }, [location]);

  return (
    <div className={`sidebar ${isExpanded ? "expanded" : "collapsed"}`}>
      <div className="top-section">
        <div className="menu-icons" onClick={onToggle}>
          {isExpanded ? (
            <AiOutlineMenuFold className="back-arrow" />
          ) : (
            <AiOutlineMenuUnfold className="back-arrow" />
          )}
        </div>
        {isExpanded && (
          <div className="logo-container">
            <div className="logo">Right Lender</div>
          </div>
        )}
      </div>
      <div className="menu-items-container">
        {!isExpanded && (
          <div className="sidebar-user-info">
            {adminData?.photo ? (
              <img
                src={decodeURIComponent(adminData.photo)}
                alt="User Avatar"
                className="user-avatar"
              />
            ) : (
              <div className="avatar-initials">
                {getInitials(adminData?.name)}
              </div>
            )}
          </div>
        )}
        {/* {isExpanded && (
          <div className="nameText">{adminData?.name}</div>
          )} */}
        {isExpanded && (
          <div className="sidebar-user-info">
            {adminData?.photo ? (
              <img
                src={decodeURIComponent(adminData.photo)}
                alt="User Avatar"
                className="sidebar-user-avatar-img"
              />
            ) : adminData?.name ? (
              <div className="sidebar-user-avatar-initials">
                {getInitials(adminData?.name)}
              </div>
            ) : (
              <img
                src={employeeProfile}
                className="side-bar-image"
                alt="Default Profile"
              />
            )}
          </div>
        )}

        <ul className="menu-items">
          {adminRole !== "customer" && (
            <li
              className={`menu-item ${selectedProduct === "dashboard" ? "selected" : ""
                }`}
              onClick={() => handleDashboardSelect()}
            >
              <div className="icon">
                <FaThLarge />
              </div>
              {isExpanded && <span className="text">Dashboard</span>}
            </li>
          )}
          <li
            className={`menu-item ${selectedProduct === "homeloan" ? "selected" : ""
              }`}
            onClick={() => handleProductSelect("homeloan", "/homeloanlist")}
          >
            <div className="icon">
              <FaHome />
            </div>
            {isExpanded && <span className="text">Home Loan</span>}
          </li>
          <li
            className={`menu-item ${selectedProduct === "personalloan" ? "selected" : ""
              }`}
            onClick={() =>
              handleProductSelect("personalloan", "/personalloanlist")
            }
          >
            <div className="icon">
              <FaUser />
            </div>
            {isExpanded && <span className="text">Personal Loan</span>}
          </li>
          <li
            className={`menu-item ${selectedProduct === "businessloan" ? "selected" : ""
              }`}
            onClick={() =>
              handleProductSelect("businessloan", "/businessloanlist")
            }
          >
            <div className="icon">
              <FaBusinessTime />
            </div>
            {isExpanded && <span className="text">Business Loan</span>}
          </li>
          {/* <li
              className={`menu-item ${
                selectedProduct === "carloan" ? "selected" : ""
              }`}
              onClick={() => handleProductSelect("carloan", "/carloanlist")}
            >
              <div className="icon">
                <FaCar />
              </div>
              {isExpanded && <span className="text">Car Loan</span>}
            </li> */}
          <li
            className={`menu-item ${selectedProduct === "mortgageloan" ? "selected" : ""
              }`}
            onClick={() =>
              handleProductSelect("mortgageloan", "/mortgageloanlist")
            }
          >
            <div className="icon">
              <FaLandmark />
            </div>
            {isExpanded && <span className="text">Mortgage Loan</span>}
          </li>
          {/* <li
              className={`menu-item ${
                selectedProduct === "creditcard" ? "selected" : ""
              }`}
              onClick={() =>
                handleProductSelect("creditcard", "/creditcardlist")
              }
            >
              <div className="icon">
                <FaCreditCard />
              </div>
              {isExpanded && <span className="text">Credit Card</span>}
            </li> */}
          {/* <li
              className={`menu-item ${
                selectedProduct === "insurance" ? "selected" : ""
              }`}
              onClick={() => handleProductSelect("insurance", "/insurancelist")}
            >
              <div className="icon">
                <FaShieldAlt />
              </div>
              {isExpanded && <span className="text">Insurance</span>}
            </li> */}
          <li
            className={`menu-item ${selectedProduct === "doctorloan" ? "selected" : ""
              }`}
            onClick={() =>
              handleProductSelect("doctorloan", "/doctorloanlist")
            }
          >
            <div className="icon">
              <FaUserMd />
            </div>
            {isExpanded && <span className="text">Doctor Loan</span>}
          </li>
          <li
            className={`menu-item ${selectedProduct === "nriloan" ? "selected" : ""
              }`}
            onClick={() =>
              handleProductSelect("nriloan", "/nriloanlist")
            }
          >
            <div className="icon">
              <FaGlobe />
            </div>
            {isExpanded && <span className="text">NRI Loan</span>}
          </li>
          {adminRole === "admin" && (
            <li
              className={`menu-item ${selectedProduct === "employee" ? "selected" : ""
                }`}
              onClick={() => handleEmployeeSelect()}
            >
              <div className="icon">
                <FaUser />
              </div>
              {isExpanded && <span className="text">Employee</span>}
            </li>
          )}

          {adminRole === "admin" && (
            <li
              className={`menu-item ${selectedProduct === "bank" ? "selected" : ""
                }`}
              onClick={() => handleProductSelect("bank", "/banklist")}
            >
              <div className="icon">
                <FaMoneyBillAlt />
              </div>
              {isExpanded && <span className="text">Bank</span>}
            </li>
          )}
          {adminRole === "admin" && (
            <li
              className={`menu-item ${selectedProduct === "company" ? "selected" : ""
                }`}
              onClick={() => handleProductSelect("company", "/companylist")}
            >
              <div className="icon">
                <FaRegAddressCard />
              </div>
              {isExpanded && <span className="text">Company</span>}
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
